import React from 'react';
import { Link } from 'react-router-dom';

export default function GalleryItem(props) {
	const { photo, index, apiService } = props;
	if (isNaN(photo.width)) {
		//console.log('photo', photo);
		photo.width = 480;
	}
	//console.log('Gallery Item', props);
	const thisURL = apiService.__getThumbSrc(photo.fileid);
	return (
		<div
			className='gi-p'
			key={index}
			style={{ width: photo.width + 'px', height: photo.height + 'px' }}
		>
			<Link to={process.env.PUBLIC_URL + '/item/' + photo.code}>
				<div className='gi-fc'>
					<div
						className='lazyl'
						data-dbg={index < 10 ? '<10' : '>=10'}
						style={{
							backgroundImage:
								index < 10 ? "url('" + thisURL + "')" : 'none',
							width: photo.width + 'px',
							height: photo.height + 'px',
							backgroundSize: 'contain',
						}}
						data-image={thisURL}
					></div>
					{/*<img src={apiService.__getFileSrc(photo.fileid)}  style={{width:(photo.width+"px"),height:(photo.height+"px")}}>
            
            </img>*/}
				</div>
			</Link>
		</div>
	);
}
